export const API_URLS = {
  RESTAURANT: 'admin/shop/system_group_restaurant/',
  SITE: 'web/queue/getSiteDetail/',
  QUEUE: 'web/queue/getQueueConfig/',
  REQUEST_TICKET: 'web/queue/requestTicket/',
  TICKET: 'web/queue/getTicketDetail/',
  PICKUP: 'web/pickup/getPickupTagList/'
}